export const arrayOfObjectsToCSV = <T extends GenericObject>(data?: T[]) => {
    if (!data || data.length === 0) return "";

    let csvContent = "";
    csvContent += `${Object.keys(data.at(0) as GenericObject).join(",")}\r\n`;

    Array.from(data).forEach((entry) => {
        const data = Object.values(entry).map((str: string) => {
            // Remove last "," from data entry error.
            const value = str && str.lastIndexOf(",") === str.length - 1 ? str.substring(0, str.length - 1) : str;
            return `"${value}"`;
        });
        csvContent += `${data}\r\n`;
    });
    return csvContent;
};
